import { h as __h } from "preact";
/** @import { scimGroupResponse, scimOrgMappingResponse } from "~/backend/validate.js"; */

import html from "~/util/html.js";
import { confirmModal } from "~/component/ConfirmModal.js";
import { saveMappings } from "./manageMappings.js";

/**
 * @param {{ enterpriseId: string }} props
 * @param {scimGroupResponse} group
 * @param {scimOrgMappingResponse} mapping
 */
export const removeMapping = async ({
  enterpriseId
}, group, mapping) => {
  const res = await confirmModal({
    title: `Remove ${mapping.org_name} from ${group.name}?`,
    action: "Remove",
    body: __h("p", {}, "While directory mappings are on, members lose access to ", mapping.org_name, " unless another\n\t\t\t\tmapping grants it.")
  });
  if (res !== true) return;
  return saveMappings({
    enterpriseId
  }, group, group.mappings.filter(m => m.org_id !== mapping.org_id));
};